'use client';
import React, { useState } from 'react';
import { Search, Filter, ChevronDown } from 'lucide-react';

const STATUS_OPTIONS = ['All Statuses', 'Pending', 'Approved', 'Rejected', 'Clocked In'];
const WEEK_OPTIONS = ['Week 18 (28 Apr – 04 May)', 'Week 17 (21 Apr – 27 Apr)', 'Week 16 (14 Apr – 20 Apr)'];

interface TimesheetFiltersProps {
  onSearch?: (v: string) => void;
  onStatus?: (v: string) => void;
  onWeek?: (v: string) => void;
  selectedCount?: number;
  onBulkApprove?: () => void;
}

export default function TimesheetFilters({
  selectedCount = 0,
  onBulkApprove,
}: TimesheetFiltersProps) {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('All Statuses');
  const [week, setWeek] = useState(WEEK_OPTIONS[0]);

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Search */}
      <div className="relative flex-1 min-w-[200px] max-w-xs">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          placeholder="Search worker name or NI number..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full pl-9 pr-3 py-2 text-[13px] bg-card border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-all"
        />
      </div>

      {/* Status filter */}
      <div className="relative">
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="appearance-none pl-3 pr-8 py-2 text-[13px] font-500 bg-card border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-all cursor-pointer"
        >
          {STATUS_OPTIONS.map((s) => (
            <option key={`status-opt-${s}`} value={s}>{s}</option>
          ))}
        </select>
        <ChevronDown size={12} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
      </div>

      {/* Week filter */}
      <div className="relative">
        <select
          value={week}
          onChange={(e) => setWeek(e.target.value)}
          className="appearance-none pl-3 pr-8 py-2 text-[13px] font-500 bg-card border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-all cursor-pointer"
        >
          {WEEK_OPTIONS.map((w) => (
            <option key={`week-opt-${w}`} value={w}>{w}</option>
          ))}
        </select>
        <ChevronDown size={12} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
      </div>

      <div className="flex items-center gap-1.5 ml-auto text-[12px] text-muted-foreground">
        <Filter size={12} />
        <span>Showing 12 timesheets</span>
      </div>

      {/* Bulk approve — slides in when rows selected */}
      {selectedCount > 0 && (
        <button
          onClick={onBulkApprove}
          className="flex items-center gap-2 px-3 py-2 text-[13px] font-600 text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 transition-all duration-150 active:scale-95 animate-slide-up"
        >
          Approve {selectedCount} selected
        </button>
      )}
    </div>
  );
}